import { post } from '.';

export function CreateSkip(options = {}) {
	return post<any>("/app/api/skips", options);
}